module.exports = __webpack_public_path__ + "img/user.8b04ad6b.svg";